import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { RecruitmentStatusRecord } from '../entities/records';
import * as selectors from '../entities/RecruitmentStatus/selectors';

function mapStateToProps(state, { recruitmentStatusIds }) {
  return {
    recruitmentStatuses: selectors.recruitmentStatusesByIds(state, recruitmentStatusIds),
  };
}

export default compose(
  setPropTypes({
    recruitmentStatusIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    recruitmentStatuses: PropTypes.arrayOf(PropTypes.instanceOf(RecruitmentStatusRecord)),
  }),
)(mapStateToProps);
